export const REPORT_AND_ANALYSIS = 'report_and_analysis';
export const TRIAGE = 'triage';
export const SURFACE_ATTACK_MANAGEMENT = 'surface_attack_management';
export const MANAGEMENT = 'management';